import config from "./config";

export const getOutlet = async (body) => {
  try {
    let res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
      method: "post",
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: "fetch",
        shopId: body,
      }),
    });
    res = await res.json();
    console.log("b232", res);

    if (res.code === "ERROR") {
      return alert(res.message);
    } else {
      return res;
    }
  } catch (err) {
    console.log("Err", err);
  }
};

export const updateARN = async (updateARN, shopId) => {
  try {
    var res = await fetch(
      `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
      {
        method: "POST",
        body: JSON.stringify({
          action: "updateARN",
          updateARN: updateARN,
          shopId: shopId,
        }),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": `${config.newApiKey}`,
        },
      }
    );
    await res.json();
  } catch (err) {
    // message.error("Error while Adding Tax. Please try again.");
  }
};
